import { render, staticRenderFns } from "./OngoingSessionsReport.vue?vue&type=template&id=38448dbc&"
import script from "./OngoingSessionsReport.vue?vue&type=script&lang=js&"
export * from "./OngoingSessionsReport.vue?vue&type=script&lang=js&"
import style0 from "./OngoingSessionsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports